import { getUserId } from "lib/idp"
import { trackAnalytics } from "services/segment"

export function useSegmentTrack() {
    const userId = getUserId()

    return {
        trackNavigation: (toPath?: string) => trackAnalytics.page({ toPath }),
        trackEvents: (eventType: string, props?: Record<string, unknown>) =>
            trackAnalytics.track(eventType, { ...props }),
        trackIdentity: () => trackAnalytics.identify(userId),
    }
}
